import { RawModel } from '@/types/rawModel';
import { useRawAssetPbrDownloads } from '@/app/components/shared/viewer/query/useRawAssetPbrDownloads';
import { getAssetImages } from '@/utils/assetUtils';
import { AssetPreview } from '@/app/components/shared/viewer/AssetPreview';
import { defaultConfig } from '@/app/components/shared/viewer/defaultConfig';
import { usePreviewTabs } from '@/app/components/shared/viewer/hooks';
import { useFetchRawModelPreview } from '@/app/components/shared/viewer/query/useRawAssetPreviewQuery';
import { CollapsibleSection } from '@/app/components/shared/viewer/CollapsibleSection';
import { isTooLargeToAutoLoad3DView } from './Viewer';

interface RawAssetPreviewProps {
  sourceAsset: RawModel;
  height?: number;
}

export function RawAssetPreview({ sourceAsset, height }: RawAssetPreviewProps) {
  const { data: preview } = useFetchRawModelPreview({
    modelId: sourceAsset.id,
  });

  const hasGlb = Object.keys(sourceAsset.downloads ?? {}).find((item) => item.includes('glb'));
  const isLarge = isTooLargeToAutoLoad3DView(sourceAsset.size);

  const { tab, setTab } = usePreviewTabs(!isLarge && hasGlb ? '3d' : undefined);
  const images = getAssetImages(sourceAsset);

  return (
    <CollapsibleSection title='Preview'>
      <AssetPreview
        glbUrl={preview?.model_url}
        images={images}
        previewConfig={preview?.config ?? JSON.stringify(defaultConfig)}
        tab={tab}
        onTabChanged={setTab}
        previewHeight={height}
        isLarge={isLarge}
      />
    </CollapsibleSection>
  );
}
